import { getAuditHistory, getActionProgress, getActionStepLog } from "@/apis";
import { createAddon, deleteAddon, disableAddon, enableAddon, listAddons, purgeModule, redeployModule, showAddonDetail, showAvailableAddonDetail, startModule, stopModule, uninstallAddon, updateAddon } from "@/apis/addons";

export const RESOURCE_TYPE_ADDONS = "addons";

const handleResponse = (response) => {
  if (response.status === "error" || response.status === "Error") {
    throw new Error(response.error);
  } else {
    return response.value;
  }
};

export const AddonsDataProvider = {
  getList: async ({ resource, pagination, filters, sorters, meta }) => {
    const response = await listAddons(meta.id);
    const data = response.value;
    return {
        data,
        total: data.length,
    };
  },  

  getOne: async ({ resource, id, meta, variables, addonId }) => {
    let response;
    // if(meta.id)
    //   response = await showAddonDetail(id, meta.addonId);
    // else
    response = await showAvailableAddonDetail(id);
    return handleResponse(response);
  },

  update: async ({ resource, id, variables: { action, addonId, data, module } }) => {
    if (action === "disable") {
      const resp = await disableAddon(id, addonId);
      return handleResponse(resp);
    } else if (action === "enable") {
      const resp = await enableAddon(id, addonId);
      return handleResponse(resp);
    } else if (action === "update") {
      const resp = await updateAddon(id, addonId, data);
      return handleResponse(resp);
    } else if(action === "edit") {
      return await updateAddon(null, id, data);
    } else if(action === "start") {
      return await startModule(id, module);
    } else if(action === "stop") {
      return await stopModule(id, module);
    } else if(action === "purge") {
      return await purgeModule(id, module);
    } else if(action === "redeploy") {
      return await redeployModule(id, module);
    }
  },

  deleteOne: async ({ resource, id, meta }) => {
    let resp;
    if(meta?.addonId)
      resp = await uninstallAddon(id, meta.addonId);
    else 
      resp = await deleteAddon(id);
    return handleResponse(resp);
  },

  create: async ({ resource, meta, variables}) => {
    const response = await createAddon(variables);
    return handleResponse(response);
  },
};
